import {
  ELASTICITY_CHARTS_REQUEST,
  ELASTICITY_CHARTS_SUCCESS,
  ELASTICITY_CHARTS_FAILURE,
} from "./elasticityChartsType";
const initialState = {
  success: false,
  loading: false,
  chartData: [],
  error: "",
};
const elasticityChartsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ELASTICITY_CHARTS_REQUEST:
      return {
        ...state,
        success: false,
        loading: action.loading,
      };
    case ELASTICITY_CHARTS_SUCCESS:
      const setSignUpState = {
        ...state,
        success: true,
        loading: action.loading,
        chartData: action.payload,
        error: "",
      };
      return setSignUpState;
    case ELASTICITY_CHARTS_FAILURE:
      return {
        ...state,
        success: false,
        loading: action.loading,
        chartData: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default elasticityChartsReducer;
